import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, effect, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NavigationItem } from '../../../../interfaces/navigationList.interface';
import { PageContainerService } from '../../../../services/page-container.service';
import {
  Dropdown,
  DropdownChangeEvent,
  DropdownModule,
} from 'primeng/dropdown';
import { tap } from 'rxjs';
import { environment } from '@envs/environment';

@Component({
  selector: 'z-top-header-tab',
  standalone: true,
  imports: [CommonModule, DropdownModule, FormsModule, RouterModule],
  templateUrl: './top-header-tab.component.html',
  styleUrls: ['./top-header-tab.component.scss'],
})
export class TopHeaderTabComponent {
  tabData = input.required<NavigationItem>();
  active = input<boolean>(false);
  activeChild!: NavigationItem | null;
  activeDropDownMenu!: NavigationItem | null;

  selectLastChild$ = this.pageContainerService.selectLastChild$.pipe(
    tap(child => {
      this.activeDropDownMenu = child;
      this.cd.detectChanges();
    }),
  );

  constructor(
    readonly router: Router,
    readonly pageContainerService: PageContainerService,
    readonly cd: ChangeDetectorRef,
  ) {
    effect(
      () => {
        if (this.active() && this.tabData()) {
          this.getRoutePath();
        } else {
          this.activeChild = null;
        }
      },
      { allowSignalWrites: true },
    );
  }

  goTo(dropdown: Dropdown) {
    if (this.tabData().children.length) {
      if (dropdown.overlayViewChild) {
        dropdown.overlayViewChild.styleClass = 'dropdown-overlay-tab-position';
      }
      dropdown.show();
    }
  }

  selectChild(ev: DropdownChangeEvent) {
    const item = ev.value as NavigationItem;
    if (item.routeUrl.length) this.router.navigate([item.routeUrl]);

    const currentPath = this.pageContainerService
      .getRoutePath()
      .find(x => x.url === item.routeUrl)?.routePath;
    if (currentPath) this.setActiveItem(currentPath);
  }

  navigateToMicroService(item: NavigationItem, hasChildren: boolean) {
    if (hasChildren) {
      return;
    }
    // If the routeUrl is a full URL, open it directly
    if (
      item.routeUrl &&
      (item.routeUrl.startsWith('http://') ||
        item.routeUrl.startsWith('https://'))
    ) {
      window.open(item.routeUrl, '_self');
      return;
    }
    const service =
      item.outsideUrlTarget === 'core' ? '' : `/${item.outsideUrlTarget}/#`;
    const url = environment.localDomain + service + item.routeUrl;
    window.open(url, '_self');
  }

  getRoutePath() {
    const currentPath = this.pageContainerService
      .getRoutePath()
      .find(x => x.url === this.router.url)?.routePath;

    if (currentPath) this.setActiveItem(currentPath);
  }

  setActiveItem(currentPath: number[]) {
    const index = this.tabData().children.findIndex(
      y => y && currentPath && y.id === currentPath[2],
    );
    if (index !== -1) {
      this.activeChild = this.tabData().children[index];
      this.activeDropDownMenu = this.tabData().children[index];
      this.cd.detectChanges();
    } else {
      return;
    }
  }
}
